import { render, staticRenderFns } from "./About.vue?vue&type=template&id=26f46bcf&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f46bcf",
  null
  
)

export default component.exports